// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {OS} from '@github-ui/get-os'
import {t} from '@github-ui/swp-core/lib/utils/localization'

import type {CtaBannerSectionPropsData} from './components/sections/CtaBannerSection/CtaBannerSection'
import type {CustomerStoriesSectionProps} from './components/sections/CustomerStoriesSection/CustomerStoriesSection'
import type {DataMarqueeSectionPropsData} from './components/sections/DataMarqueeSection/DataMarqueeSection'
import type {FeaturesSectionProps} from './components/sections/FeaturesSection/FeaturesSection'
import type {FooterSectionPropsData} from './components/sections/FooterSection/FooterSection'
import type {HeroSectionPropsData} from './components/sections/HeroSection/HeroSection'
import type {IntroSectionPropsData} from './components/sections/IntroSection/IntroSection'
import type {ShowcaseSectionPropsData} from './components/sections/ShowcaseSection/ShowcaseSection'
import type {TestimonialsSectionProps} from './components/sections/TestimonialsSection/TestimonialsSection'
import type {DownloadMenu, SignUpField} from './Index.types'
import type {DataMarqueeEventData} from './components/generic/DataMarquee/DataMarquee'
import type {FeaturedRepository} from './components/generic/MonaFooter/MonaFooter'

import ImageAvatar1 from './assets/images/_mock/avatar-1.jpg'
import ImageAvatar2 from './assets/images/_mock/avatar-2.jpg'
import ImageAvatar3 from './assets/images/_mock/avatar-3.jpg'
import ImageAvatar4 from './assets/images/_mock/avatar-4.jpg'
import ImageAvatar5 from './assets/images/_mock/avatar-5.jpg'
import ImageFeaturePlatform1Light from './assets/images/_mock/features-platform-1-light.jpg'
import ImageFeaturePlatform2Light from './assets/images/_mock/features-platform-2-light.jpg'
import ImageFeatureWays1Light from './assets/images/_mock/features-ways-1-light.jpg'
import ImageFeatureWays2Light from './assets/images/_mock/features-ways-2-light.jpg'
import ImageFeatureWays3Light from './assets/images/_mock/features-ways-3-light.jpg'
import ImageFeatureWays4Light from './assets/images/_mock/features-ways-4-light.jpg'
import ImageFeatureWays5Light from './assets/images/_mock/features-ways-5-light.jpg'
import ImageFeaturePlatform1Dark from './assets/images/_mock/features-platform-1-dark.jpg'
import ImageFeaturePlatform2Dark from './assets/images/_mock/features-platform-2-dark.jpg'
import ImageFeatureWays1Dark from './assets/images/_mock/features-ways-1-dark.jpg'
import ImageFeatureWays2Dark from './assets/images/_mock/features-ways-2-dark.jpg'
import ImageFeatureWays3Dark from './assets/images/_mock/features-ways-3-dark.jpg'
import ImageFeatureWays4Dark from './assets/images/_mock/features-ways-4-dark.jpg'
import ImageFeatureWays5Dark from './assets/images/_mock/features-ways-5-dark.jpg'
import ImageCustomerStoryLogo1 from './assets/images/_mock/customerStories-logo-1.png'
import ImageCustomerStoryLogo2 from './assets/images/_mock/customerStories-logo-2.png'
import ImageCustomerStoryLogo3 from './assets/images/_mock/customerStories-logo-3.png'
import ImageDuckyShadows from './assets/images/ducky-shadows.png'
import VideoHeroLight from './assets/videos/_mock/hero-light.mp4'
import VideoHeroDark from './assets/videos/_mock/hero-dark.mp4'

export interface CopyData {
  intro: IntroSectionPropsData
  hero: HeroSectionPropsData
  dataMarquee: DataMarqueeSectionPropsData
  showcase?: ShowcaseSectionPropsData
  features: FeaturesSectionProps
  ctaBanner: CtaBannerSectionPropsData
  testimonials: TestimonialsSectionProps
  customerStories: CustomerStoriesSectionProps
  footer: FooterSectionPropsData
}

// TODO: Add new strings to global translation deck once known
const DOWNLOAD_ACTIONS: DownloadMenu['actions'] = [
  {
    id: 'macos-arm',
    platform: OS.macOS,
    architecture: 'arm',
    label: t('Download for macOS (Silicon)'),
    url: 'https://gh.io/copilot-app-mac',
  },
  {
    id: 'macos-x86',
    platform: OS.macOS,
    architecture: 'x86',
    label: t('Download for macOS (Intel)'),
    url: 'https://gh.io/copilot-app-mac-intel',
  },
  {
    id: 'windows-x86',
    platform: OS.Windows,
    architecture: 'x86',
    label: t('Download for Windows (x64)'),
    url: 'https://gh.io/copilot-app-win64',
  },
  {
    id: 'windows-arm',
    platform: OS.Windows,
    architecture: 'arm',
    label: t('Download for Windows (ARM)'),
    url: 'https://gh.io/copilot-app-win-arm',
  },
  {
    id: 'linux',
    platform: OS.Linux,
    label: t('Download for Linux'),
    url: 'https://gh.io/copilot-app-linux',
  },
]

// TODO: Update once known
// TODO: Add new strings to global translation deck once known
const DOWNLOAD_MENU_LABEL = t('Other download options')

const SIGN_UP_FIELD: SignUpField = {
  label: t('Enter your email'),
  placeholder: 'you@domain.com',
  cta: {
    label: t('Sign up for GitHub'),
    url: '/signup',
  },
}

export const MOCK_RECENT_EVENTS: DataMarqueeEventData[] = [
  {
    data: {
      type: 'pull_request_opened',
      actorLogin: 'natalie-iv',
      repositoryNameWithOwner: 'github/github-app',
      timestamp: '2026-10-14T15:00:00Z',
      url: '/github/github-app/pull/1',
    },
  },
  {
    data: {
      type: 'pull_request_merged',
      actorLogin: 'natalieharris',
      repositoryNameWithOwner: 'nasa/mars',
      timestamp: '2026-10-14T14:58:00Z',
      url: '/nasa/mars/pull/1',
    },
  },
  {
    data: {
      type: 'repository_forked',
      actorLogin: 'natalieharris',
      repositoryNameWithOwner: 'nasa/mars',
      timestamp: '2026-10-14T14:57:00Z',
      url: '/nasa/mars',
    },
  },
  {
    data: {
      type: 'repository_starred',
      actorLogin: 'beckharu',
      repositoryNameWithOwner: 'app/desktop-system',
      timestamp: '2026-10-14T14:56:00Z',
      url: '/app/desktop-system',
    },
  },
  {
    data: {
      type: 'push',
      actorLogin: 'octocat',
      repositoryNameWithOwner: 'github/docs',
      timestamp: '2026-10-14T14:55:00Z',
      url: '/github/docs/commits/main',
    },
  },
  {
    data: {
      type: 'pull_request_opened',
      actorLogin: 'monalisa',
      repositoryNameWithOwner: 'primer/react',
      timestamp: '2026-10-14T14:54:00Z',
      url: '/primer/react/pull/321',
    },
  },
  {
    data: {
      type: 'repository_starred',
      actorLogin: 'hubot',
      repositoryNameWithOwner: 'github/opensource.guide',
      timestamp: '2026-10-14T14:53:00Z',
      url: '/github/opensource.guide',
    },
  },
  {
    data: {
      type: 'pull_request_merged',
      actorLogin: 'dependabot',
      repositoryNameWithOwner: 'github/docs',
      timestamp: '2026-10-14T14:52:00Z',
      url: '/github/docs/pull/456',
    },
  },
  {
    data: {
      type: 'repository_forked',
      actorLogin: 'codercat',
      repositoryNameWithOwner: 'octocat/Hello-World',
      timestamp: '2026-10-14T14:51:00Z',
      url: '/octocat/Hello-World',
    },
  },
  {
    data: {
      type: 'push',
      actorLogin: 'scubtocat',
      repositoryNameWithOwner: 'github/github-app',
      timestamp: '2026-10-14T14:50:00Z',
      url: '/github/github-app/commits/main',
    },
  },
  {
    data: {
      type: 'pull_request_opened',
      actorLogin: 'octocat',
      repositoryNameWithOwner: 'primer/react',
      timestamp: '2026-10-14T14:49:00Z',
      url: '/primer/react/pull/654',
    },
  },
  {
    data: {
      type: 'repository_starred',
      actorLogin: 'monalisa',
      repositoryNameWithOwner: 'microsoft/vscode',
      timestamp: '2026-10-14T14:48:00Z',
      url: '/microsoft/vscode',
    },
  },
]

export const MOCK_FEATURED_REPOS: FeaturedRepository[] = [
  {
    nameWithOwner: 'github/docs',
    description: 'The open source documentation for GitHub.',
    url: '/github/docs',
    newStars: 432,
  },
  {
    nameWithOwner: 'facebook/react',
    description: 'A library for building user interfaces.',
    url: '/facebook/react',
    newStars: 1284,
  },
  {
    nameWithOwner: 'microsoft/vscode',
    description: 'A streamlined code editor with support for development workflows.',
    url: '/microsoft/vscode',
    newStars: 976,
  },
  {
    nameWithOwner: 'vercel/next.js',
    description: 'A React framework for building full-stack web applications.',
    url: '/vercel/next.js',
    newStars: 843,
  },
  {
    nameWithOwner: 'denoland/deno',
    description: 'A secure runtime for JavaScript and TypeScript.',
    url: '/denoland/deno',
    newStars: 615,
  },
  {
    nameWithOwner: 'rust-lang/rust',
    description: 'A language for reliable and efficient software.',
    url: '/rust-lang/rust',
    newStars: 588,
  },
  {
    nameWithOwner: 'golang/go',
    description: 'The Go programming language.',
    url: '/golang/go',
    newStars: 541,
  },
  {
    nameWithOwner: 'kubernetes/kubernetes',
    description: 'A system for automating deployment, scaling, and management of containerized applications.',
    url: '/kubernetes/kubernetes',
    newStars: 503,
  },
  {
    nameWithOwner: 'tensorflow/tensorflow',
    description: 'An open source platform for machine learning.',
    url: '/tensorflow/tensorflow',
    newStars: 467,
  },
  {
    nameWithOwner: 'huggingface/transformers',
    description: 'State-of-the-art machine learning for multiple data modalities.',
    url: '/huggingface/transformers',
    newStars: 742,
  },
  {
    nameWithOwner: 'astral-sh/ruff',
    description: 'A fast Python linter and code formatter.',
    url: '/astral-sh/ruff',
    newStars: 691,
  },
  {
    nameWithOwner: 'oven-sh/bun',
    description: 'An all-in-one toolkit for JavaScript and TypeScript applications.',
    url: '/oven-sh/bun',
    newStars: 634,
  },
]

const HERO_SEQUENCE_CHAPTER_DURATIONS = [4.466667, 5.766667, 9.166667, 13.433333, 4.566667]

export const HERO_SEQUENCE_CHAPTER_TIMESTAMPS: number[] = HERO_SEQUENCE_CHAPTER_DURATIONS.map((_, index) =>
  HERO_SEQUENCE_CHAPTER_DURATIONS.slice(0, index).reduce((elapsed, duration) => elapsed + duration, 0),
)

// TODO: Update once known
const HERO_SEQUENCE_CHAPTER_ALT_DESCRIPTIONS = [
  'Copilot reviews proposed code changes.',
  'Copilot works directly on a requested fix.',
  'Copilot checks the completed work.',
  'Copilot prepares the changes for approval and merge.',
  'Copilot ships the completed work.',
]

// TODO: Update links once known
export const MOCK_COPY_DATA: CopyData = {
  intro: {
    monaHead: {
      // TODO: Update once known (optional)
      alt: '',
    },
    eyebrowBanner: {
      image: {
        url: {
          light: ImageDuckyShadows,
        },
        // TODO: Update once known (optional)
        alt: '',
      },
      text: 'GitHub Universe ‘26 Recap',
      url: '/events/universe/recap',
    },
    title: 'Software still starts with you',
    ctas: {
      trial: {
        label: 'Start a free trial',
        url: '/organizations/enterprise_plan',
      },
      sales: {
        label: 'Contact sales',
        url: '/enterprise/contact',
      },
      signUp: SIGN_UP_FIELD,
      downloadCta: {
        label: 'Download GitHub Copilot app',
        url: '/features/copilot/download',
      },
      downloadMenu: {
        menuLabel: DOWNLOAD_MENU_LABEL,
        actions: DOWNLOAD_ACTIONS,
      },
    },
  },
  hero: {
    a11y: {
      // TODO: Update once known
      title: 'Product walkthrough',
    },
    heroSequence: {
      // TODO: Update once known
      chaptersAltDesc: HERO_SEQUENCE_CHAPTER_ALT_DESCRIPTIONS,
      video: {
        url: {
          dark: VideoHeroDark,
          light: VideoHeroLight,
        },
        chapterTimestamps: HERO_SEQUENCE_CHAPTER_TIMESTAMPS,
      },
    },
    heroPagination: {
      items: ['Review changes', 'Direct the fix', 'Check the results', 'Approve and merge', 'See it shipped'],
      // TODO: Update once known
      a11y: {
        pagination: {
          title: 'Product walkthrough chapters',
          previous: 'Previous chapter',
          next: 'Next chapter',
        },
        playButton: {
          play: 'Play the product walkthrough',
          pause: 'Pause the product walkthrough',
          replay: 'Replay from beginning',
        },
      },
    },
  },
  dataMarquee: {
    stats: [
      {
        data: {
          value: '150M+',
          label: 'developers building on GitHub',
        },
      },
      {
        data: {
          value: '230+',
          label: 'repositories created every minute',
        },
      },
      {
        data: {
          value: '43M+',
          label: 'pull requests merged each month',
        },
      },
    ],
    copy: {
      events: {
        labelTemplate: {
          pull_request_opened: {action: 'pull request', text: '{action} from {actorLogin}'},
          pull_request_merged: {action: 'branch merged', text: '{action} from {actorLogin}'},
          repository_forked: {action: 'repo forked', text: '{action} from {actorLogin}'},
          repository_starred: {action: 'repo starred', text: '{action} by {actorLogin}'},
          push: {action: 'push', text: '{action} from {actorLogin}'},
        },
      },
    },
    // TODO: Update once known
    a11y: {
      title: 'GitHub activity',
      play: 'Play activity',
      pause: 'Pause activity',
    },
  },
  showcase: {
    title: 'Copilot now on your desktop',
    description: 'Built around your repositories. Ready for more than code.',
    cta1: {
      type: 'download',
      menuLabel: DOWNLOAD_MENU_LABEL,
      actions: DOWNLOAD_ACTIONS,
    },
    cta2: {
      label: 'Learn more',
      url: '/features/copilot',
    },
    visual: {
      type: 'video',
      url: {
        dark: VideoHeroDark,
        light: VideoHeroLight,
      },
      // TODO: Update once known
      alt: 'GitHub Copilot desktop interface',
    },
  },
  features: {
    items: [
      {
        title: 'GitHub Platform',
        items: [
          {
            title: 'GitHub',
            description: 'Repository hosting, code review, and collaboration.',
            icon: 'mark-github',
            visual: {
              url: {
                dark: ImageFeaturePlatform1Dark,
                light: ImageFeaturePlatform1Light,
              },
              // TODO: Update once known
              alt: 'A pull request with a merge stack',
            },
            cta1: {
              label: 'Learn more',
              url: '/features',
            },
            cta2: {
              label: 'See plans and pricing',
              url: '/pricing',
            },
          },
          {
            title: 'Copilot',
            description: 'AI coding agent with repository context.',
            icon: 'mark-github',
            visual: {
              url: {
                dark: ImageFeaturePlatform2Dark,
                light: ImageFeaturePlatform2Light,
              },
              // TODO: Update once known
              alt: 'GitHub Copilot working with repository context',
            },
            cta1: {
              label: 'Learn more',
              url: '/features/copilot',
            },
            cta2: {
              label: 'See plans and pricing',
              url: '/features/copilot/plans',
            },
          },
        ],
      },
      {
        title: 'More ways to use GitHub',
        items: [
          {
            title: 'Actions',
            description: 'CI/CD and automation.',
            visual: {
              url: {
                dark: ImageFeatureWays1Dark,
                light: ImageFeatureWays1Light,
              },
              // TODO: Update once known
              alt: 'A successful GitHub Actions workflow',
            },
            cta1: {
              label: 'Explore Actions',
              url: '/features/actions',
            },
          },
          {
            title: 'Code Quality',
            description: 'Code quality analysis and autofixes.',
            visual: {
              url: {
                dark: ImageFeatureWays2Dark,
                light: ImageFeatureWays2Light,
              },
              // TODO: Update once known
              alt: 'A code quality autofix suggestion',
            },
            cta1: {
              label: 'Explore Code Quality',
              url: '/features/code-review',
            },
          },
          {
            title: 'Code Security',
            description: 'Vulnerability detection and response.',
            visual: {
              url: {
                dark: ImageFeatureWays3Dark,
                light: ImageFeatureWays3Light,
              },
              // TODO: Update once known
              alt: 'A code injection security alert',
            },
            cta1: {
              label: 'Explore Code Security',
              url: '/security/advanced-security/code-security',
            },
          },
          {
            title: 'Secret Protection',
            description: 'Secret scanning and leak prevention.',
            visual: {
              url: {
                dark: ImageFeatureWays4Dark,
                light: ImageFeatureWays4Light,
              },
              // TODO: Update once known
              alt: 'A leaked password security alert',
            },
            cta1: {
              label: 'Explore Secret Protection',
              url: '/security/advanced-security/secret-protection',
            },
          },
          {
            title: 'Codespaces',
            description: 'Cloud development environments.',
            visual: {
              url: {
                dark: ImageFeatureWays5Dark,
                light: ImageFeatureWays5Light,
              },
              // TODO: Update once known
              alt: 'A GitHub Codespaces environment selector',
            },
            cta1: {
              label: 'Explore Codespaces',
              url: '/features/codespaces',
            },
          },
        ],
      },
    ],
  },
  ctaBanner: {
    monaDivider: {
      // TODO: Update once known (optional)
      alt: '',
    },
    ctaBanner: {
      title: "Whatever you're building, you can build it on GitHub",
      cta: {
        label: 'Start Enterprise free trial',
        url: '/organizations/enterprise_plan',
      },
    },
  },
  testimonials: {
    data: {
      items: [
        {
          quote:
            'With the time savings Copilot unlocks, our developers are empowered to spend more time on the tasks they enjoy the most — creative-problem solving, innovative projects and experimentation.',
          author: {
            name: 'Dionysios Satikidis',
            position: 'Head of AI Accelerator, Mercedes-Benz',
            avatar: {
              url: ImageAvatar1,
              alt: '',
            },
          },
        },
        {
          quote:
            'GitHub has been critical to evolving our software development lifecycle. We now average about 4,000 commits daily, a speed that just wouldn’t have been possible otherwise.',
          author: {
            name: 'Jermaine Davis',
            position: 'Distinguished Engineer, Home Depot',
            avatar: {
              url: ImageAvatar2,
              alt: '',
            },
          },
        },
        {
          quote: 'GitHub helps us build better solutions, faster. And in the end, it’s our clients who benefit.',
          author: {
            name: 'Dan Schocke',
            position: 'Application architect, Accenture',
            avatar: {
              url: ImageAvatar3,
              alt: '',
            },
          },
        },
        {
          quote:
            'With GitHub Copilot, our developers stay in the flow state and keep momentum instead of clawing through code libraries or documentation.',
          author: {
            name: 'Jonathan Burket',
            position: 'Engineering Director, Duolingo',
            avatar: {
              url: ImageAvatar4,
              alt: '',
            },
          },
        },
        {
          quote:
            "GitHub is one of the de facto tools that engineers want to use, and because of that, we don't have long, expensive onboarding periods or productivity gaps.",
          author: {
            name: 'Rob Witoff',
            position: 'CTO, Coinbase',
            avatar: {
              url: ImageAvatar5,
              alt: '',
            },
          },
        },
      ],
      stats: [
        {
          value: '800M',
          label: 'public and open source repositories',
        },
        {
          value: '90%',
          label: 'of the Fortune 100 uses GitHub',
        },
      ],
      // TODO: Update once known
      a11y: {
        title: 'What our customers say',
        testimonialGroup: {
          controlsPrev: 'Previous testimonial',
          controlsNext: 'Next testimonial',
          controlsNavigation: 'Testimonial navigation',
          carouselRoleDescription: 'carousel',
          slideRoleDescription: 'slide',
          indicator: 'Go to testimonial {current}',
          slide: 'Testimonial {current} of {total}',
          announcement: 'Testimonial {current} of {total}: {author}',
        },
      },
    },
    logoMarquee: {
      logos: ['Duolingo', 'FedEx', 'American Airlines', 'Postmates', 'Mercado Libre'],
      // TODO: Update once known
      a11y: {
        title: 'Companies using GitHub',
      },
    },
  },
  customerStories: {
    items: [
      {
        logo: {
          url: {
            light: ImageCustomerStoryLogo1,
          },
          alt: 'Figma',
        },
        description: 'Figma streamlines development and strengthens security',
        cta: {
          label: 'Read customer story',
          url: '/customer-stories/figma',
        },
      },
      {
        logo: {
          url: {
            light: ImageCustomerStoryLogo2,
          },
          // TODO: Update once known
          alt: 'Mercedes-Benz',
        },
        description: 'Mercedes-Benz standardizes source code and automates onboarding',
        cta: {
          label: 'Read customer story',
          url: '/customer-stories/mercedes-benz',
        },
      },
      {
        logo: {
          url: {
            light: ImageCustomerStoryLogo3,
          },
          // TODO: Update once known
          alt: 'Mercado Libre',
        },
        description: 'Mercado Libre cuts coding time by 50%with GitHub Copilot',
        cta: {
          label: 'Read customer story',
          url: '/customer-stories/mercado-libre',
        },
      },
    ],
    // TODO: Update once known
    a11y: {
      title: 'Customer stories',
    },
  },
  footer: {
    monaFooter: {
      mona: {
        // TODO: Update once known (optional)
        alt: '',
      },
      repos: {
        a11y: {
          // TODO: Update once known
          title: 'Featured repositories',
        },
        starsTemplate: '{newStars} new stars this week',
      },
    },
    communityFooter: {
      label: 'Built with GitHub',
      title: "Join the world's\nlargest developer community",
      description:
        'Every project adds something new to the community. Explore what developers are building across GitHub, then create an account and contribute your own.',
      signUp: SIGN_UP_FIELD,
    },
  },
}
